import { createFileRoute } from '@tanstack/react-router'
import node, {
  type proposalActivityPageQuery,
} from '#gen/relay/proposalActivityPageQuery.graphql'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

export const Route = createFileRoute(
  '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/activity',
)({
  staticData: { title: '[graph] - Proposal Activity' },
  loader({ context, params }) {
    return context.preload<proposalActivityPageQuery>(node, {
      accountSlug: params.account,
      proposalId: params.id,
    })
  },
  component: lazyLoadedComponent(
    () =>
      import(
        '#app/pages/branch/proposals/proposal-page/activity-page/proposal-activity-page'
      ),
    'ProposalActivityPage',
  ),
})
